import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SwitchToggleComponent } from "./switch-toggle/switch-toggle.component";
import { CheckboxComponent } from "./checkbox/checkbox.component";
import { InputModule } from "./input/input.module";

@NgModule({
  declarations: [SwitchToggleComponent, CheckboxComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, InputModule],
  exports: [SwitchToggleComponent, CheckboxComponent, InputModule],
})
export class FormControlsModule {}
